import { render, staticRenderFns } from "./ButtonToggleCollapse.vue?vue&type=template&id=a1948cea&scoped=true&"
import script from "./ButtonToggleCollapse.vue?vue&type=script&lang=js&"
export * from "./ButtonToggleCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToggleCollapse.vue?vue&type=style&index=0&id=a1948cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1948cea",
  null
  
)

export default component.exports